import React, { Component } from "react";
import { hot } from "react-hot-loader";
import { Router, Route, Switch, Head } from "react-static";
import { browserHistory } from "react-router";
import ReactGA from "react-ga";
import Intercom from "react-intercom";
import {
  Link,
  DirectLink,
  Element,
  Events,
  animateScroll as scroll,
  scrollSpy,
  scroller
} from "react-scroll";

import queryString from "query-string";

import "./app.scss";
import Home from "pages/Home";
import Invite from "pages/Invite";

import logo from "./images/logo.png";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      vis: true,
      email: null
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ vis: true });
    }, 100);
    const parsed = queryString.parse(location.search);
    this.setState({ email: parsed.e });

    ReactGA.initialize("UA-55881946-29");
    ReactGA.pageview(window.location.pathname + window.location.search);

  }

  render() {
    return (
      <div className={`app ${this.state.vis && "app-vis"}`}>
        <Head>
          <title>
            toos | A simple way to balance shared spending in your relationship.
          </title>
        </Head>

        <div className="site-header">
          <div className="header">
            <a href="/">
              <img src={logo} className="logo" />
            </a>

            <div>
              {/* {typeof document !== "undefined" &&
                (window.location.href.indexOf("invite") > -1 ? (
                  <Link to="invite" spy={true} smooth={true} duration={500}>
                    <button>
                      <span>Invite</span>
                    </button>
                  </Link>
                ) : (
                  !this.state.email && (
                    <Link to="signup" spy={true} smooth={true} duration={500}>
                      <button>
                        <span>Sign up</span>
                      </button>
                    </Link>
                  )
                ))} */}

              <button
                className="contact"
                onClick={() => {
                  window.open('mailto:hello@neu.studio')
                }}
              >
                <span>Contact</span>
              </button>
            </div>
          </div>
        </div>

        <Router>
          <Switch>
            <Route exact path="/" render={props => <Home {...props} />} />
            <Route
              exact
              path="/invite"
              render={props => <Invite {...props} />}
            />
          </Switch>
        </Router>

        <div className="footer">
          <div className="footer-inner">
            {/* <a href="https://twitter.com/toosHQ" target="_blank">
              <h3>@toosHQ</h3>
            </a> */}
            <button
              className="contact"
              onClick={() => {
                window.open('mailto:hello@neu.studio')
              }}
            >
              <span>Contact</span>
            </button>
          </div>
        </div>

        <Intercom appID="uprknq5h" />
      </div>
    );
  }
}

export default hot(module)(App);



// WEBPACK FOOTER //
// /Users/grantmaclennan/code/_archive/Toos/src/App.js